export default __webpack_public_path__ + "static/medio-5614ff89f658b388973a32bf72cb60cc.png";